import * as THREE from 'three'
import { Helper } from '../../../../../../classes/helper'
import { cover } from '../../../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../../../context/montage.context'
import { LedSpotlight } from '../../../../../utility/light/LedSpotlight'
import { LedSpot } from '../../../../../utility/light/LedSpot'
import { useEffect, useRef } from 'react'
interface Props {
  positionX: number
}
export const WindowsTopBar = ({ positionX }: Props): JSX.Element => {

  const { measure, roof, ledSpots } = useMontage()
  const extrudedRound = new THREE.CylinderGeometry(0.03, 0.03, 0.002, 36)

  const quantity: any = ledSpots?.quantity.match(/\d/g)
  const type: any = ledSpots?.type.match(/\d/g)
  const x: any = +quantity[0]
  const y: number = +type[0]
  const unit: number = x > 0 ? 2 : 0

  const glowYellow = new THREE.MeshBasicMaterial({
    color: new THREE.Color(7, 4, 0.5),
    toneMapped: false,
  })

  return (
    <>
      {positionX !== 0 && (
        <>
          <mesh
            position={[
              Helper.convertToMeter(
                measure.userWidth! / 2 - measure.windowsTopWidth! * positionX!
              ),
              Helper.convertToMeter(measure.userHeight!),
              Helper.convertToMeter(
                measure.userDepth! / 2 + cover.bar.depth / 2
              ),
            ]}
            castShadow={cover.terraceCover.castShadow}
            rotation={[Helper.convertAngleToRadiant(measure.userAngle!), 0, 0]}
          >
            <boxGeometry
              args={[
                Helper.convertToMeter(cover.bar.width),
                Helper.convertToMeter(cover.bar.height),
                Helper.convertToMeter(
                  measure.userDepth! +
                    +Helper.extendTopElements(measure.userAngle)
                ),
              ]}
            />
            <meshPhysicalMaterial
              color={roof.userColor}
              transparent
              opacity={1}
            />
            {[...Array(unit)].map((_, index) => {
              return (
                // <LedSpot/>
                <LedSpot
                  geometry={extrudedRound}
                  material={glowYellow}
                  position={[
                    0,
                    -0.0425,
                    Helper.convertToMeter(
                      measure.userDepth! +
                        +Helper.extendTopElements(measure.userAngle)
                    ) /
                      6 -
                      (index *
                        Helper.convertToMeter(
                          measure.userDepth! +
                            +Helper.extendTopElements(measure.userAngle)
                        )) /
                        3,
                  ]}
                />
              )
            })}
          </mesh>
        </>
      )}
    </>
  )
}
